export default "__VITE_ASSET__DnKuBHlN__"